import React from "react";
import _ from "lodash";
import $ from "jquery";
import {
  getData,
  parseBody,
  parseTryout,
  TRYOUT_STATE_FORM,
} from "./helpers/tryout";
import { formattedDate, spaceJSONText } from "../../constants/misc";
import queryString from "query-string";
import TryItOut from "./redoc-tryout";
import TryoutTour from "./redocTryoutTour/redocTryoutTour";
import RedocTimeline from "./redocHistory/redocTimeline";
import Fab from "../fab/fab";
import HistoryIcon from "../svgs/historyIcon";
import MoveBox from "../moveBox/MoveBox";
import LightBulb from "../svgs/lightbulb";
import RedocParamTextArea from "./redocParamBody/redocParamBody";
import RedocAuthPopup from "./redocAuthPopup/redocAuthPopup";
import * as actions from "../../actions";
import { connect } from "react-redux";
import RedocTryOutModalFailedResponsesForm from "./TryOutFailedResponsesModal/TryOutFailedResponsesModal";
import { parseApplications } from "../../constants/parse/application";

class RedocTryoutManager extends React.Component {
  state = {
    shouldOpenResponse: false,
    historyItem: null,
    onTour: false,
    popup: null,
    active: null,
    elements: [],
    tryoutsVisible: false,
    tryoutsMinified: false,
    showHistory: false,
    pinned: null,
    tryOutCurrentRequest: null,
    responses: [],
    openTryOutModal: true,
    modalTextareaValue: "",
  };

  // Scroll detection properties
  isScrolling = false;
  scrollEndTimer = null;

  // Track processed operations to avoid duplicates
  processedOperations = new Set();
  lastScanTimestamp = 0;

  stopTour = () => {
    this.setState({
      onTour: false,
    });
  };

  startTour = () => {
    this.setState({
      onTour: true,
    });
  };

  toggleHistory = () => {
    this.setState({
      showHistory: !this.state.showHistory,
    });
  };

  handleScroll = () => {
    const { elements, active, pinned, tryoutsVisible } = this.state;
    const { swaggerJson } = this.props;
    const validHttpMethods = [
      "get",
      "post",
      "put",
      "delete",
      "patch",
      "head",
      "options",
    ];

    // If pinned is true, don't change the active operation
    if (pinned) return;

    // Only proceed if tryout window is visible and not pinned
    if (!tryoutsVisible) return;

    // Don't process if no elements
    if (!elements || elements.length === 0) {
      return;
    }

    let scrollPosition = window.scrollY;
    let newActive = elements.findIndex(
      (element) => element.offsetTop > scrollPosition
    );
    newActive =
      newActive > 0
        ? newActive - 1
        : newActive === -1
        ? elements.length - 1
        : 0;

    const newActiveElement = elements[newActive];

    // Check if we have a valid element and it's different from current
    if (!newActiveElement) return;
    if (
      active &&
      active.path === newActiveElement.path &&
      active.method === newActiveElement.method
    ) {
      return; // still on the same operation
    }
    {
      const { path, method } = newActiveElement;

      // Validate that we have a valid HTTP method
      if (!method || !validHttpMethods.includes(method.toLowerCase())) {
        console.warn(
          `Invalid HTTP method detected: ${method} for path ${path}`
        );
        return;
      }

      // Get parameters and security from swagger
      let parameters = [];
      let security = [];

      if (swaggerJson?.paths?.[path]?.[method]) {
        const operationData = swaggerJson.paths[path][method];
        parameters = operationData.parameters || [];

        // Extract security definitions
        if (swaggerJson.components?.securitySchemes) {
          security = Object.keys(swaggerJson.components.securitySchemes).map(
            (key) => {
              let result = swaggerJson.components.securitySchemes[key];
              if (result.type === "oauth2") {
                result = {
                  ...result,
                  name: "Authorization",
                  in: "header",
                };
              }
              return result;
            }
          );
        }
      }

      // Parse body for the request
      const body = parseBody(method, path, swaggerJson);
      const { documentationId } = this.props;

      // Create the tryout only if the user has not opened this operation before -
      // createTryout replaces the form, which would wipe anything already typed.
      if (!this.props.tryouts?.[path]?.[method]) {
        this.props.createTryout({
          documentationId,
          path: path,
          method: method,
          parameters: parameters,
          security: security,
          form: {
            ...TRYOUT_STATE_FORM,
            body: body || null, // Ensure body is at least null, not undefined
          },
        });
      }

      // Update active state (same shape as everywhere else: {path, method})
      this.setState({
        active: { path, method },
      });

      // Make sure the tryout window stays visible with full data
      this.showTryout({ path, method, parameters, security });
      // Ensure the form stays shown
      this.tryoutsShow(path, method);
    }
  };

  componentWillUnmount() {
    // Remove scroll event listener for Try Out window tracking
    if (this.handleScrollDebounced) {
      this.handleScrollDebounced.cancel();
      window.removeEventListener("scroll", this.handleScrollDebounced);
    }

    // Remove scroll tracking listener
    if (this.handleScrollStart) {
      window.removeEventListener("scroll", this.handleScrollStart);
    }

    // Clear scroll timers
    if (this.scrollEndTimer) {
      clearTimeout(this.scrollEndTimer);
    }

    // Clean up MutationObserver
    if (this.observer) {
      this.observer.disconnect();
    }

    // Clear any pending scan timeouts
    if (this.scanTimeout) {
      clearTimeout(this.scanTimeout);
    }

    // Clear adjustHeights timeout
    if (this.adjustHeightsTimeout) {
      clearTimeout(this.adjustHeightsTimeout);
    }

    // Clear processed operations set
    this.processedOperations.clear();
  }

  componentDidUpdate(prevProps, prevState) {
    // Handle selectedItem changes (when user clicks on TOC items)
    if (
      this.props.selectedItem !== prevProps.selectedItem &&
      this.props.selectedItem
    ) {
      const { selectedItem } = this.props;

      // Only update tryout if it's an endpoint and we're not pinned
      if (selectedItem.type === "endpoint" && !this.state.pinned) {
        console.log(
          "[TRYOUT SELECTION] TOC selection changed, updating tryout:",
          {
            newSelection: `${selectedItem.method} ${selectedItem.path}`,
            isPinned: !!this.state.pinned,
            currentActive: this.state.active,
            timestamp: new Date().toISOString(),
          }
        );

        // Update active state to follow the selection
        this.setState({
          active: {
            path: selectedItem.path,
            method: selectedItem.method.toLowerCase(),
          },
        });

        // If tryout is visible, update it to show the new selection
        if (this.state.tryoutsVisible) {
          const { swaggerJson, documentationId } = this.props;
          const method = selectedItem.method.toLowerCase();
          const path = selectedItem.path;

          // Get parameters and security from swagger
          let parameters = [];
          let security = [];

          if (swaggerJson?.paths?.[path]?.[method]) {
            const operationData = swaggerJson.paths[path][method];
            parameters = operationData.parameters || [];

            // Extract security definitions
            if (swaggerJson.components?.securitySchemes) {
              security = Object.keys(
                swaggerJson.components.securitySchemes
              ).map((key) => {
                let result = swaggerJson.components.securitySchemes[key];
                if (result.type === "oauth2") {
                  result = {
                    ...result,
                    name: "Authorization",
                    in: "header",
                  };
                }
                return result;
              });
            }
          }

          // Parse body for the request
          const body = parseBody(method, path, swaggerJson);

          // Create/update the tryout in Redux
          this.props.createTryout({
            documentationId,
            path: path,
            method: method,
            parameters: parameters,
            security: security,
            form: {
              ...TRYOUT_STATE_FORM,
              body: body || null,
            },
          });

          // Show the tryout for the new selection
          this.showTryout({ path, method, parameters, security });

          // Also update the tryout to ensure it's displayed
          this.props.updateTryout({
            documentationId,
            path: path,
            method: method,
            values: {
              formShown: true,
              minified: false,
            },
          });
        }
      } else if (selectedItem.type === "endpoint" && this.state.pinned) {
        console.log(
          "[TRYOUT SELECTION] TOC selection changed but tryout is PINNED:",
          {
            newSelection: `${selectedItem.method} ${selectedItem.path}`,
            pinnedTo: this.state.pinned,
            timestamp: new Date().toISOString(),
          }
        );
      }
    }

    if (
      (this.props.response && !prevProps.response) ||
      (this.props.response &&
        prevProps.response &&
        this.props.response.created !== prevProps.response.created)
    ) {
      this.setState({
        shouldOpenResponse: true,
        responses: [...prevState.responses, this.props.response],
      });
    }

    // Check if any tryout has formShown: true that wasn't shown before
    const { tryouts } = this.props;
    const prevTryouts = prevProps.tryouts;

    console.log("[TRYOUT DEBUG] 7. RedocTryoutManager componentDidUpdate:", {
      hasTryouts: !!tryouts,
      hasPrevTryouts: !!prevTryouts,
      tryoutsChanged: tryouts !== prevTryouts,
      currentTryoutsKeys: tryouts ? Object.keys(tryouts) : [],
    });

    if (tryouts && tryouts !== prevTryouts) {
      // Find any tryout with formShown: true
      let foundActiveTryout = null;
      let shouldForceShow = false;

      console.log("[TRYOUT DEBUG] 8. Scanning tryouts for formShown...");

      Object.keys(tryouts || {}).forEach((path) => {
        Object.keys(tryouts[path] || {}).forEach((method) => {
          const tryout = tryouts[path][method];
          const prevTryout =
            prevTryouts && prevTryouts[path] && prevTryouts[path][method];

          console.log(`[TRYOUT DEBUG] 9. Checking ${method} ${path}:`, {
            hasFormShown: tryout?.formShown,
            hasToggleForm: tryout?.toggleForm,
            prevFormShown: prevTryout?.formShown,
            prevToggleForm: prevTryout?.toggleForm,
            timestamp: tryout?.timestamp,
            prevTimestamp: prevTryout?.timestamp,
          });

          // Check if formShown changed from false/undefined to true
          // OR if toggleForm is true (indicates user clicked Try Out)
          // OR if timestamp changed (indicates a new click on the same tryout)
          if (
            tryout &&
            tryout.formShown &&
            (!prevTryout ||
              !prevTryout.formShown ||
              (tryout.toggleForm && (!prevTryout || !prevTryout.toggleForm)) ||
              (prevTryout && tryout.formShown && !prevTryout.formShown) ||
              (tryout.timestamp &&
                prevTryout &&
                tryout.timestamp !== prevTryout.timestamp))
          ) {
            console.log(
              `[TRYOUT DEBUG] 10. Found active tryout: ${method} ${path}`,
              {
                timestampChanged: tryout.timestamp !== prevTryout?.timestamp,
                currentTimestamp: tryout.timestamp,
                prevTimestamp: prevTryout?.timestamp,
                isPinned: !!this.state.pinned,
              }
            );
            foundActiveTryout = { path, method };
            // Force show if toggleForm is true (user clicked button)
            if (tryout.toggleForm) {
              shouldForceShow = true;
            }
          }
        });
      });

      // If we found a tryout with formShown: true, update the active state
      if (foundActiveTryout) {
        console.log("[TRYOUT STATE UPDATE] Found new active tryout:", {
          newActive: foundActiveTryout,
          currentActive: this.state.active,
          isPinned: !!this.state.pinned,
          pinnedTo: this.state.pinned,
          willDisplay: this.state.pinned || foundActiveTryout,
          timestamp: new Date().toISOString(),
        });

        // ALWAYS update the active state to track the current selection
        // The render method will decide whether to show pinned or active
        this.setState({
          tryoutsVisible: true,
          active: foundActiveTryout,
        });

        // Clear the toggleForm flag after using it
        const { updateTryout } = this.props;
        if (
          updateTryout &&
          tryouts[foundActiveTryout.path][foundActiveTryout.method].toggleForm
        ) {
          console.log("[TRYOUT DEBUG] 12. Clearing toggleForm flag");
          updateTryout({
            documentationId: this.props.documentationId,
            path: foundActiveTryout.path,
            method: foundActiveTryout.method,
            values: {
              toggleForm: false,
            },
          });
        }
      } else {
        console.log("[TRYOUT DEBUG] 13. No active tryout found");
      }
    }
  }

  componentDidMount() {
    let _this = this;
    const { swaggerJson, tryoutResponseClear, documentationId } = this.props;

    // Clear any previous responses
    tryoutResponseClear({ documentationId });

    // Add scroll event listener to track when user is scrolling
    this.handleScrollStart = () => {
      this.isScrolling = true;
      clearTimeout(this.scrollEndTimer);

      // Consider scroll ended after 150ms of no scroll events
      this.scrollEndTimer = setTimeout(() => {
        this.isScrolling = false;
      }, 150);
    };

    window.addEventListener("scroll", this.handleScrollStart, {
      passive: true,
    });

    // Enable scroll-based Try Out window updates (only works when not pinned)
    this.handleScrollDebounced = _.debounce(this.handleScroll, 150);
    window.addEventListener("scroll", this.handleScrollDebounced);

    // Initialize MutationObserver to watch for Redoc operations
    this.initializeMutationObserver();

    // Also try to initialize immediately in case content is already loaded
    setTimeout(() => {
      this.scanForOperations();
      // Try to inject tour button immediately as well
      this.injectTourButton();
    }, 1000);

    // Try again after a bit more time to ensure everything is loaded
    setTimeout(() => {
      this.injectTourButton();
    }, 2000);
    [2500, 5000].forEach((delay) => {
      setTimeout(() => this.scanForOperations(), delay);
    });
  }

  initializeMutationObserver = () => {
    const { swaggerJson, documentationId } = this.props;

    // Create observer to watch for DOM changes
    this.observer = new MutationObserver((mutations) => {
      // Skip processing if user is currently scrolling
      if (this.isScrolling) {
        return;
      }

      let shouldScan = false;

      // Check if any of the mutations might contain operations
      for (const mutation of mutations) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              // Element node
              const element = node;
              const text = element.textContent || "";

              // Check if this might be an operation element
              if (
                text.match(/\b(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS)\b/i) ||
                element.id?.includes("operation") ||
                element.getAttribute?.("data-section-id") ||
                element.querySelector?.(
                  '[id*="operation"], [data-section-id*="/paths/"], [data-section-id*="operation/"]'
                )
              ) {
                shouldScan = true;
                break;
              }
            }
          }
        }
        if (shouldScan) break;
      }

      // If we found potential operations, scan the document
      if (shouldScan && !this.isScrolling) {
        // Increased debounce time to avoid interfering with scroll
        clearTimeout(this.scanTimeout);
        this.scanTimeout = setTimeout(() => {
          // Double-check that we're not scrolling before scanning
          if (!this.isScrolling) {
            this.scanForOperations();
          }
        }, 500); // Increased from 100ms to 500ms
      }
    });

    // Start observing the document body for changes
    const targetNode = document.body;
    const config = {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    };

    this.observer.observe(targetNode, config);
  };

  scanForOperations = () => {
    // Skip if user is scrolling
    if (this.isScrolling) {
      return;
    }

    // Implement minimum time between scans (1 second)
    const now = Date.now();
    if (now - this.lastScanTimestamp < 1000) {
      return;
    }
    this.lastScanTimestamp = now;

    const { swaggerJson, documentationId, tourData } = this.props;

    // Multiple strategies to find operations
    const operations = this.findOperations();

    // Filter out already processed operations
    const newOperations = operations.filter((op) => {
      const operationKey = `${op.method}-${op.path}`;
      return !this.processedOperations.has(operationKey);
    });

    if (newOperations.length === 0) {
      // Check if we need to inject the tour button
      this.injectTourButton();
      return;
    }

    // Process each new operation
    newOperations.forEach((op) => {
      const operationKey = `${op.method}-${op.path}`;
      this.processedOperations.add(operationKey);
      this.processOperation(op, swaggerJson, documentationId);
    });
    // "Entities" (schemas) stays where the swagger's description puts it - right after
    // "Feedback and Questions", as on the old portal. It used to be moved to the end of the
    // page, which on long APIs (e.g. i-bank ERP Sandbox) left it out of sight.

    // Inject tour button after processing operations
    this.injectTourButton();

    // Only call adjustHeights if we actually added new operations
    if (newOperations.length > 0) {
      // Debounce adjustHeights to prevent it from being called too frequently
      clearTimeout(this.adjustHeightsTimeout);
      this.adjustHeightsTimeout = setTimeout(() => {
        this.adjustHeights();
      }, 300);
    }
  };

  // Redoc 2.x renders every operation as a content section whose id encodes it:
  //   tag/<Tag>/paths/<json-pointer-path>/<method>   (no operationId in the spec)
  //   [tag/<Tag>/]operation/<operationId>            (operationId present)
  // Sidebar entries use data-item-id, so this never matches the menu.
  findRedocOperationSections = () => {
    const { swaggerJson } = this.props;
    const operations = [];
    const byOperationId = (operationId) => {
      const paths = swaggerJson?.paths || {};
      for (const path of Object.keys(paths)) {
        for (const method of Object.keys(paths[path] || {})) {
          if (paths[path][method]?.operationId === operationId) {
            return { path, method: method.toLowerCase() };
          }
        }
      }
      return null;
    };
    $(document)
      .find('[data-section-id*="/paths/"], [data-section-id*="operation/"]')
      .each(function () {
        if ($(this).attr("data-tryout-processed")) return;
        const sectionId = $(this).attr("data-section-id") || "";
        let found = null;
        const pathMatch = sectionId.match(/\/paths\/(.+)\/([a-z]+)$/i);
        if (pathMatch) {
          found = {
            path: pathMatch[1].replace(/~1/g, "/").replace(/~0/g, "~"),
            method: pathMatch[2].toLowerCase(),
          };
        } else {
          const opMatch = sectionId.match(/operation\/(.+)$/);
          if (opMatch) found = byOperationId(opMatch[1]);
        }
        if (found) {
          operations.push({ element: this, ...found, source: "redoc-section" });
        }
      });
    return operations;
  };

  findOperations = () => {
    const redocSections = this.findRedocOperationSections();
    if (redocSections.length > 0) {
      return redocSections;
    }
    const operations = [];
    const httpMethods = [
      "GET",
      "POST",
      "PUT",
      "DELETE",
      "PATCH",
      "HEAD",
      "OPTIONS",
    ];

    // Strategy 1: Find elements with operation IDs
    $(document)
      .find('[id*="operation/"], [id*="operation-"]')
      .each(function () {
        const id = $(this).attr("id");
        if (!$(this).attr("data-tryout-processed")) {
          // Parse operation from ID
          const match = id.match(/operation[\/\-]([a-z]+)[\/\-](.+)/i);
          if (match) {
            operations.push({
              element: this,
              method: match[1].toLowerCase(),
              path: "/" + match[2].replace(/-/g, "/"),
              source: "id",
            });
          }
        }
      });

    // Strategy 2: Find h2/h3 elements containing operations
    $(document)
      .find("h2, h3")
      .each(function () {
        if (!$(this).attr("data-tryout-processed")) {
          const text = $(this).text();
          // Look for pattern like "GET /accounts"
          const match = text.match(
            /\b(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS)\s+(\/[^\s]+)/i
          );
          if (match) {
            operations.push({
              element: $(this).parent()[0] || this,
              method: match[1].toLowerCase(),
              path: match[2],
              source: "heading",
            });
          }
        }
      });

    // Strategy 3: Find elements containing just HTTP methods
    $(document)
      .find("span, div, button")
      .each(function () {
        const text = $(this).text().trim();
        if (
          httpMethods.includes(text.toUpperCase()) &&
          !$(this).attr("data-tryout-processed") &&
          $(this).children().length === 0
        ) {
          // Look for path in siblings or parent
          let path = null;
          const parent = $(this).parent();

          // Check siblings
          $(this)
            .siblings()
            .each(function () {
              const sibText = $(this).text().trim();
              if (sibText.startsWith("/") && !path) {
                path = sibText.split(" ")[0]; // Take just the path part
              }
            });

          // Check parent text if no path found
          if (!path) {
            const parentText = parent.text();
            const pathMatch = parentText.match(/(\/[^\s\)]+)/);
            if (pathMatch) {
              path = pathMatch[1];
            }
          }

          if (path) {
            operations.push({
              element: parent[0] || this,
              method: text.toLowerCase(),
              path: path,
              source: "method-element",
            });
          }
        }
      });

    // Remove duplicates based on method + path
    const seen = new Set();
    const uniqueOperations = operations.filter((op) => {
      const key = `${op.method}-${op.path}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });

    return uniqueOperations;
  };

  processOperation = (operation, swaggerJson, documentationId) => {
    const { element, method, path, source } = operation;

    // Mark as processed to avoid duplicates
    $(element).attr("data-tryout-processed", "true");

    console.log(`Processing operation: ${method} ${path} (source: ${source})`);

    // Check if this operation exists in swagger
    if (!swaggerJson?.paths?.[path]?.[method]) {
      console.warn(`Operation not found in swagger: ${method} ${path}`);
      return;
    }

    // Extract operation details from swagger
    const operationData = swaggerJson.paths[path][method];
    const parameters = operationData.parameters || [];

    // Extract security definitions
    let security = [];
    if (swaggerJson.components?.securitySchemes) {
      security = Object.keys(swaggerJson.components.securitySchemes).map(
        (key) => {
          let result = swaggerJson.components.securitySchemes[key];
          if (result.type === "oauth2") {
            result = {
              ...result,
              name: "Authorization",
              in: "header",
            };
          }
          return result;
        }
      );
    }

    // Create tryout data
    // Several oauth2 schemes (authorization code + client credentials) all map to the same
    // Authorization header - show that row once.
    {
      const seen = new Set();
      security = security.filter((scheme) => {
        const key = `${scheme.in}:${scheme.name}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }
    const body = parseBody(method, path, swaggerJson);
    this.props.createTryout({
      documentationId,
      path: path,
      method: method,
      parameters: parameters,
      security: security,
      form: {
        ...TRYOUT_STATE_FORM,
        body: body,
      },
    });

    // One TRY-OUT button per operation, placed in Redoc's right (samples) panel like the
    // live portal. Only content sections qualify - the text-matching fallbacks can also hit
    // the sidebar menu, which is why injection had been switched off altogether.
    if (source === "redoc-section") {
      this.injectTryOutButton(element, method, path, parameters, security);
    }
  };

  injectTryOutButton = (element, method, path, parameters, security) => {
    const $element = $(element);
    if ($element.find(".tryout-button-injected").length > 0) {
      return;
    }
    const button = $("<button>")
      .attr("type", "button")
      .attr("class", "btn electro tryout-button-injected")
      .text("TRY-OUT")
      .click((e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setActiveTryout(path, method);
        this.showTryout({ path, method, parameters, security });
        this.tryoutsShow(path, method);
      });
    const wrapper = $(
      '<div class="simple_btn tryout-button-wrapper"></div>'
    ).append(button);

    // Redoc section = <div id=...><div row><div middle/><div right/></div></div>
    const rowChildren = $element.children().first().children();
    const rightPanel = rowChildren.length >= 2 ? rowChildren.last() : null;
    if (rightPanel && rightPanel.length > 0) {
      rightPanel.prepend(wrapper);
    } else {
      $element.prepend(wrapper);
    }
    console.log(`Injected Try Out button for ${method} ${path}`);
  };

  injectTourButton = () => {
    const { tourData } = this.props;

    console.log("Attempting to inject tour button. Tour data:", tourData);

    // Only inject if we have tour data and button doesn't exist
    if (!tourData || tourData.length === 0) {
      console.log("No tour data available, skipping tour button injection");
      return;
    }

    // Check if tour button already exists
    if ($(document).find(".tour-button-injected").length > 0) {
      return;
    }

    // Create the tour button with more prominent styling
    const tourButton = $("<button>")
      .attr("class", "btn electro tour-button-injected")
      .css({
        position: "fixed",
        bottom: "20px",
        right: "20px",
        padding: "12px 24px",
        fontSize: "14px",
        textTransform: "uppercase",
        backgroundColor: "#005782",
        color: "white",
        border: "none",
        borderRadius: "25px",
        cursor: "pointer",
        fontWeight: "600",
        zIndex: "9999",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
        transition: "all 0.3s ease",
      })
      .html(
        '<i class="fa fa-play-circle" style="margin-right: 8px;"></i> TAKE THE TOUR'
      )
      .click(() => {
        this.startTour();
        // Hide the button after starting the tour
        $(this).fadeOut();
      })
      .hover(
        function () {
          $(this).css({
            backgroundColor: "#003d5a",
            transform: "scale(1.05)",
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.4)",
          });
        },
        function () {
          $(this).css({
            backgroundColor: "#005782",
            transform: "scale(1)",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
          });
        }
      );

    // Also add a banner at the top of the page for better visibility
    const tourBanner = $("<div>")
      .attr("class", "tour-banner-injected")
      .css({
        position: "sticky",
        top: "0",
        left: "0",
        right: "0",
        backgroundColor: "#005782",
        color: "white",
        padding: "10px 20px",
        textAlign: "center",
        zIndex: "9998",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        borderBottom: "2px solid #003d5a",
      })
      .html(
        '<span style="font-size: 14px;"><i class="fa fa-info-circle" style="margin-right: 8px;"></i>Interactive tour available! Click the button to explore API endpoints step by step.</span>'
      )
      .append(
        $("<button>")
          .css({
            padding: "6px 16px",
            fontSize: "12px",
            backgroundColor: "white",
            color: "#005782",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "600",
          })
          .text("START TOUR")
          .click(() => {
            this.startTour();
            // Hide the banner after starting
            tourBanner.fadeOut();
            tourButton.fadeOut();
          })
      );

    // Inject the floating button
    $("body").append(tourButton);

    // Try multiple locations for the banner
    let targetContainer = $(".swagger-page-container").first();
    if (targetContainer.length === 0) {
      targetContainer = $(".main-panel").first();
    }
    if (targetContainer.length === 0) {
      targetContainer = $("#root").first();
    }

    if (targetContainer.length > 0) {
      targetContainer.prepend(tourBanner);
    }

    console.log("Injected Tour button and banner");
  };

  // Legacy initialization method - kept for reference but no longer used
  // Replaced with MutationObserver approach in scanForOperations()
  initializeTryoutButtons = () => {
    // This method is deprecated - operations are now detected via MutationObserver
    console.log(
      "Legacy initializeTryoutButtons called - this should not happen"
    );
    return;

    const { swaggerJson, documentationId } = this.props;
    let _this = this;

    console.log("Initializing tryout buttons...");

    // Strategy 1: Look for operation sections with data-section-id
    let operationSections = $(document).find('[data-section-id*="operation/"]');
    console.log(
      "Found operation sections with data-section-id:",
      operationSections.length
    );

    // Also look for tag sections that might contain operations
    let tagSections = $(document).find('[data-section-id^="tag/"]');
    console.log("Found tag sections:", tagSections.length);

    let operationElements = [];

    if (operationSections.length > 0) {
      // Parse operations from section IDs
      operationSections.each(function () {
        const sectionId = $(this).attr("data-section-id");
        if (sectionId && sectionId.includes("operation/")) {
          // Extract method and path from section ID
          // Format is usually: operation/[method]/[path]
          const parts = sectionId.replace("operation/", "").split("/");
          if (parts.length >= 2) {
            const method = parts[0].toLowerCase();
            const path = "/" + parts.slice(1).join("/");
            operationElements.push({ element: this, method, path });
          }
        }
      });
    }

    // Check if operations are nested under tag sections
    if (operationElements.length === 0 && tagSections.length > 0) {
      console.log("Checking for operations under tag sections...");
      tagSections.each(function () {
        // Look for operation blocks within tag sections
        const tagElement = $(this);
        const nestedOperations = tagElement.find(
          '[id*="operation/"], [data-section-id*="operation/"]'
        );

        nestedOperations.each(function () {
          const id = $(this).attr("id") || $(this).attr("data-section-id");
          if (id && id.includes("operation/")) {
            const parts = id.replace("operation/", "").split("/");
            if (parts.length >= 2) {
              const method = parts[0].toLowerCase();
              const path = "/" + parts.slice(1).join("/");
              operationElements.push({ element: this, method, path });
            }
          }
        });
      });
    }

    // Strategy 2: Look for code blocks/snippets that contain operations
    if (operationElements.length === 0) {
      console.log("Looking for code blocks with API operations...");

      // Look for code blocks that might contain API endpoints
      const codeBlocks = $(document).find(
        'pre, code, [class*="code"], [class*="snippet"]'
      );
      console.log("Found code blocks:", codeBlocks.length);

      codeBlocks.each(function () {
        const text = $(this).text();
        // Check for patterns like "GET /accounts" or "POST /consents"
        const operationPattern =
          /\b(GET|POST|PUT|DELETE|PATCH|HEAD|OPTIONS)\s+(\/[^\s]+)/gi;
        const matches = text.matchAll(operationPattern);

        for (const match of matches) {
          const method = match[1].toLowerCase();
          const path = match[2];

          // Find the parent section
          const section = $(this).closest(
            "[data-section-id], [id], .section, article"
          );
          if (section.length > 0) {
            operationElements.push({
              element: section[0],
              method,
              path,
            });
            console.log(`Found operation in code block: ${method} ${path}`);
          }
        }
      });
    }

    // Strategy 3: If no sections found, search for HTTP method text
    if (operationElements.length === 0) {
      console.log(
        "No operation sections found, searching by HTTP method text..."
      );

      const httpMethods = [
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS",
      ];
      const allElements = $(document).find("*");

      allElements.each(function () {
        const text = $(this).text().trim().toUpperCase();
        // Check if this element contains ONLY an HTTP method (not as part of larger text)
        if (httpMethods.includes(text) && $(this).children().length === 0) {
          // Found an HTTP method element, now find the path
          const parent = $(this).parent();
          let path = "";

          // Look for path in siblings or parent's children
          const siblings = $(this).siblings();
          siblings.each(function () {
            const siblingText = $(this).text().trim();
            if (siblingText.startsWith("/")) {
              path = siblingText;
              return false; // break the loop
            }
          });

          // If no path found in siblings, check parent's text
          if (!path) {
            const parentText = parent.text().trim();
            const pathMatch = parentText.match(/(\/[^\s]+)/);
            if (pathMatch) {
              path = pathMatch[1];
            }
          }

          if (path) {
            operationElements.push({
              element: parent[0] || this,
              method: text.toLowerCase(),
              path,
            });
          }
        }
      });
    }

    // Strategy 4: Legacy selectors as final fallback
    if (operationElements.length === 0) {
      console.log("Trying legacy selectors...");
      let legacyElements = $(document).find(".operation-type, .http-verb");

      if (legacyElements.length > 0) {
        legacyElements.each(function () {
          const verbNode = $(this);
          const method = verbNode.text().trim().toLowerCase();

          let path = verbNode.next("span").text().trim();
          if (!path) {
            path = verbNode.siblings(".operation-path").text().trim();
          }
          if (!path) {
            const parent = verbNode.parent();
            path =
              parent.find(".operation-path").text().trim() ||
              parent.find("span").not(".operation-type").first().text().trim();
          }

          if (path) {
            operationElements.push({ element: this, method, path });
          }
        });
      }
    }

    console.log(`Found ${operationElements.length} total operations`);

    // Debug: If no operations found, analyze the page structure
    if (operationElements.length === 0) {
      console.log("DEBUG: No operations found, analyzing page structure...");

      // Look for any potential API paths mentioned in the document
      const allText = $(document).find("*").text();
      const pathPattern = /\/[a-z][a-z0-9-_\/{}]*/gi;
      const potentialPaths = allText.match(pathPattern);
      if (potentialPaths) {
        const uniquePaths = [...new Set(potentialPaths)].slice(0, 10);
        console.log("Potential API paths found in document:", uniquePaths);
      }

      // Check if swagger has paths defined
      if (swaggerJson && swaggerJson.paths) {
        const swaggerPaths = Object.keys(swaggerJson.paths);
        console.log("Paths defined in swagger:", swaggerPaths.slice(0, 10));

        // If we have swagger paths but couldn't find them in HTML,
        // there might be a rendering issue or they haven't rendered yet
        if (swaggerPaths.length > 0) {
          console.log(
            "WARNING: Swagger has paths but they are not found in HTML. Redoc might still be rendering."
          );

          // Try to create buttons for swagger paths anyway
          swaggerPaths.forEach((path) => {
            const methods = Object.keys(swaggerJson.paths[path]);
            methods.forEach((method) => {
              // Find a suitable container for the button
              const container = $(document)
                .find('.api-content, [class*="api"], main')
                .first();
              if (container.length > 0) {
                console.log(`Creating fallback button for ${method} ${path}`);
                operationElements.push({
                  element: container[0],
                  method,
                  path,
                  isFallback: true,
                });
              }
            });
          });
        }
      }
    }

    console.log(`Total operations to process: ${operationElements.length}`);

    // Process found operations
    operationElements.forEach((op) => {
      const { element, method, path, isFallback } = op;

      console.log(
        `Processing operation: ${method} ${path}${
          isFallback ? " (fallback)" : ""
        }`
      );

      // Check if path exists in swagger
      if (
        !swaggerJson["paths"] ||
        !swaggerJson["paths"][path] ||
        !swaggerJson["paths"][path][method]
      ) {
        console.warn(`Path not found in swagger: ${method} ${path}`);
        return;
      }

      const parameters = swaggerJson["paths"][path][method]["parameters"];
      const security =
        swaggerJson.components && swaggerJson.components.securitySchemes
          ? swaggerJson.components.securitySchemes
          : null;
      let temp = [];
      if (security) {
        temp = Object.keys(security).map((key) => {
          let result = security[key];
          if (security[key].type && security[key].type === "oauth2") {
            result = {
              ...result,
              name: "Authorization",
              in: "header",
            };
          }
          return result;
        });
      }

      // Check for duplicated type property oauth
      let multipleOauthFlows =
        temp.filter((t) => t.type === "oauth2").length > 1;
      if (multipleOauthFlows) temp.splice(2, 1);

      const body = parseBody(method, path, swaggerJson);

      this.props.createTryout({
        documentationId,
        path: path,
        method: method,
        parameters: parameters,
        security: temp,
        form: {
          ...TRYOUT_STATE_FORM,
          body: body,
        },
      });

      const button = $("<button>")
        .attr("class", "btn electro")
        .css({
          margin: "1rem 0",
          marginRight: ".5rem",
          fontSize: "11px",
          textTransform: "uppercase",
        })
        .text("try-out")
        .click(() => {
          this.scrollToElement(path, method);
          this.showTryout({ path, method, parameters, security });
          this.tryoutsShow(path, method);
        });

      // Find the right place to insert the button
      const $element = $(element);
      let buttonContainer = null;

      // Special handling for fallback buttons
      if (isFallback) {
        // For fallback, create a dedicated section for Try Out buttons
        let tryoutSection = $("#tryout-buttons-section");
        if (tryoutSection.length === 0) {
          tryoutSection = $(
            '<div id="tryout-buttons-section" class="tryout-buttons-section"></div>'
          );
          tryoutSection.html(
            "<h3>API Try Out Buttons</h3><p>Click a button below to try out an API endpoint:</p>"
          );
          $element.prepend(tryoutSection);
        }
        buttonContainer = tryoutSection;
      } else if ($element.attr("data-section-id")) {
        // For data-section-id elements, insert at the beginning of the section
        buttonContainer = $element.find("> div > div").first();
        if (buttonContainer.length === 0) {
          buttonContainer = $element;
        }
      } else {
        // For other elements, try parent structure
        buttonContainer = $element.parent().parent();
        if (buttonContainer.length === 0) {
          buttonContainer = $element.parent();
        }
        if (buttonContainer.length === 0) {
          buttonContainer = $element;
        }
      }

      // Customize button text to include the endpoint
      if (isFallback) {
        button.text(`Try ${method.toUpperCase()} ${path}`);
      }

      // Wrap button in container and append/prepend
      const buttonWrapper = $('<div class="simple_btn"></div>').append(button);
      if (isFallback) {
        buttonContainer.append(buttonWrapper);
      } else {
        buttonContainer.prepend(buttonWrapper);
      }
    });

    // Handle tab clicks - try new selectors first
    let tabs = $(document).find('[role="tab"]');
    if (tabs.length === 0) {
      tabs = $(document).find(".react-tabs__tab");
    }

    tabs.on("click", function (event, stop) {
      if (!stop) {
        const text = $(this).text();
        tabs.filter(`:contains('${text}')`).trigger("click", [true]);
        _this.adjustHeights();
      }
    });

    if (this.props.tourData) {
      const tourButton = $("<button>")
        .attr("class", "btn electro")
        .attr("style", "float: right;font-size:.8rem;")
        .text("TAKE THE TOUR")
        .click(this.startTour);

      const div = $("<div class='simple_btn' />").append(tourButton);

      // Try to find API info section with different selectors
      let apiInfo = $(document).find(".api-info");
      if (apiInfo.length === 0) {
        apiInfo = $(document).find('[data-section-id="api-info"]');
      }
      if (apiInfo.length > 0) {
        apiInfo.prepend(div);
      }
    }

    _this.adjustHeights();
    // Disabled auto-scrolling - no longer tracking scroll events
    // window.addEventListener("scroll", this.handleScroll);
  };

  scrollToElement = (path, method) => {
    // Disabled auto-scrolling to prevent unwanted scroll behavior
    return;

    // Original code kept for reference:
    // const { elements } = this.state;
    // const element = elements.find(
    //   (el) => el.path === path && el.method === method
    // );
    // if (element && window.innerWidth > 900) {
    //   window.scroll({
    //     top: element.offsetTop + 24,
    //     behavior: "smooth",
    //   });
    // }
  };

  adjustHeights = () => {
    // This method is simplified since we're not using scroll-based Try Out updates
    const parents = [];
    const validHttpMethods = [
      "get",
      "post",
      "put",
      "delete",
      "patch",
      "head",
      "options",
    ];

    // Strategy 1: Look for operation sections with data-section-id
    let operationSections = $(document).find('[data-section-id*="operation/"]');

    if (operationSections.length > 0) {
      operationSections.each(function () {
        const sectionId = $(this).attr("data-section-id");
        if (sectionId && sectionId.includes("operation/")) {
          // Extract method and path from section ID
          const parts = sectionId.replace("operation/", "").split("/");
          if (parts.length >= 2) {
            const method = parts[0].toLowerCase();
            const path = "/" + parts.slice(1).join("/");

            // Only add if it's a valid HTTP method (skip "tag" and other non-HTTP methods)
            if (validHttpMethods.includes(method)) {
              const offsetTop = $(this).offset().top;
              if (offsetTop) {
                parents.push({
                  path,
                  method,
                  offsetTop,
                });
              }
            }
          }
        }
      });
    }

    // Strategy 2: If no sections found, use legacy approach
    if (parents.length === 0) {
      let operationElements = $(document).find(".operation-type, .http-verb");

      operationElements.toArray().map((c) => {
        const verbNode = $(c);
        const method = verbNode.text().trim().toLowerCase();

        // Try to find path in various ways
        let path = verbNode.next("span").text().trim();
        if (!path) {
          path = verbNode.siblings(".operation-path").text().trim();
        }
        if (!path) {
          const parent = verbNode.parent();
          path =
            parent.find(".operation-path").text().trim() ||
            parent.find("span").not(".operation-type").first().text().trim();
        }

        // Find the section container
        let section = $(c).closest("[data-section-id]");
        if (section.length === 0) {
          // Try alternative section selectors
          section =
            $(c).closest(".operation-block") ||
            $(c).closest("[id^='operation/']") ||
            $(c).closest("div[id]");
        }

        if (section.length > 0 && path) {
          const offsetTop = section.offset().top;
          if (offsetTop) {
            parents.push({
              path,
              method,
              offsetTop,
            });
          }
        }
      });
    }

    // Strategy 3: Search by HTTP method text if still no results
    if (parents.length === 0) {
      const httpMethods = [
        "GET",
        "POST",
        "PUT",
        "DELETE",
        "PATCH",
        "HEAD",
        "OPTIONS",
      ];
      const allElements = $(document).find("*");

      allElements.each(function () {
        const text = $(this).text().trim().toUpperCase();
        if (httpMethods.includes(text) && $(this).children().length === 0) {
          const parent = $(this).parent();
          let path = "";

          const siblings = $(this).siblings();
          siblings.each(function () {
            const siblingText = $(this).text().trim();
            if (siblingText.startsWith("/")) {
              path = siblingText;
              return false;
            }
          });

          if (!path) {
            const parentText = parent.text().trim();
            const pathMatch = parentText.match(/(\/[^\s]+)/);
            if (pathMatch) {
              path = pathMatch[1];
            }
          }

          if (path) {
            const section = $(this).closest(
              "[data-section-id], .operation-block, [id]"
            );
            if (section.length > 0) {
              const offsetTop = section.offset().top;
              if (offsetTop) {
                parents.push({
                  path,
                  method: text.toLowerCase(),
                  offsetTop,
                });
              }
            }
          }
        }
      });
    }

    // Sort elements by offsetTop
    parents.sort((a, b) => a.offsetTop - b.offsetTop);

    this.setState({
      elements: parents,
    });
  };

  pinTryOut = (tryout) => {
    const { pinned, active } = this.state;
    // Toggle pinned state
    // When pinning: Store the current tryout (path/method) to keep it locked
    // When unpinning: Clear pinned state to allow following selected operations
    const newPinnedState = !pinned ? tryout || active : null;

    console.log("[TRYOUT PIN] ==== PIN BUTTON CLICKED ====", {
      action: !pinned ? "PINNING" : "UNPINNING",
      wasPinned: !!pinned,
      nowPinned: !!newPinnedState,
      tryoutPassedIn: tryout,
      currentActive: active,
      pinnedTo: newPinnedState,
      willShowAfterToggle: newPinnedState || active,
      timestamp: new Date().toISOString(),
    });

    this.setState({
      pinned: newPinnedState,
    });

    // If we just unpinned, force a re-render to show the active operation
    if (pinned && !newPinnedState) {
      console.log(
        "[TRYOUT PIN] Unpinned - forcing update to show active:",
        active
      );
      // We're unpinning - ensure the tryout shows the current active operation
      this.forceUpdate();
    }
  };

  showTryout = (values) => {
    const { documentationId } = this.props;
    // Don't clear pinned state here - let the user control it via the pin button
    this.props.showTryout({
      documentationId,
      ...values,
    });
  };

  updateTryout = (path, method, values) => {
    const { documentationId } = this.props;
    this.props.updateTryout({
      documentationId,
      path,
      method,
      values,
    });
  };

  tryoutRequestCompleted = (item, success, data, args) => {
    const { documentationId } = this.props;
    const { path, method } = item;
    const values = {
      loading: false,
      response: {
        success: success,
        data: {
          body: spaceJSONText(data),
        },
      },
      args,
    };
    this.props.tryoutRequestCompleted({
      documentationId,
      path,
      method,
      values,
    });
    this.setState({
      tryOutCurrentRequest: null,
      historyItem:
        args && args.fromTryoutHistory
          ? {
              ...this.state.historyItem,
              ...values,
            }
          : this.state.historyItem,
    });
  };

  setActiveTryout = (path, method) => {
    console.log("[TRYOUT ACTIVE] Setting active tryout:", {
      path,
      method,
      currentActive: this.state.active,
      isPinned: !!this.state.pinned,
      pinnedTo: this.state.pinned,
      timestamp: new Date().toISOString(),
    });
    // Always update the active state to track current selection
    // The render method will decide whether to show pinned or active
    this.setState({
      active: { path, method },
      tryoutsVisible: true,
    });
  };

  tryoutsShow = (path, method) => {
    this.setState({
      tryoutsVisible: true,
      // tryoutsMinified: false
    });
    this.updateTryout(path, method, {
      minified: false,
    });
  };

  tryoutsToggle = () => {
    // When closing the tryout, if we're unpinned, clear the pinned state
    // to ensure next open will show the current selection
    const newVisible = !this.state.tryoutsVisible;

    console.log("[TRYOUT VISIBILITY] Toggling tryout visibility:", {
      action: newVisible ? "OPENING" : "CLOSING",
      wasVisible: this.state.tryoutsVisible,
      willBeVisible: newVisible,
      currentActive: this.state.active,
      isPinned: !!this.state.pinned,
      pinnedTo: this.state.pinned,
      timestamp: new Date().toISOString(),
    });

    if (!newVisible && !this.state.pinned) {
      // Closing while unpinned - clear any stale state
      this.setState({
        tryoutsVisible: false,
      });
    } else {
      this.setState({
        tryoutsVisible: newVisible,
      });
    }
  };

  tryoutsMinify = () => {
    this.setState({
      tryoutsMinified: true,
    });
  };

  closeAuthPopup = () => {
    this.setState({
      popup: null,
    });
  };

  authorize = (data) => {
    return this.setState({
      popup: {
        url: data.url,
        callbackSuccess: (data) => {
          this.tryoutRequestCompleted(
            { path: "/authorize", method: "get" },
            true,
            data,
            null
          );
          this.closeAuthPopup();
        },
        callbackFail: () => {
          const message = "Something went wrong please try again";
          this.tryoutRequestCompleted(
            { path: "/authorize", method: "get" },
            false,
            message,
            null
          );
          this.closeAuthPopup();
        },
      },
    });
  };

  sendRequest = (path, method, form, args = null) => {
    // const errors = this.validate(path, method, form);
    const errors = [];
    if (args && args.fromTryoutHistory) {
      this.updateHistoryItemToTryout(path, method, {
        loading: !(errors && errors.length > 0),
        formErrors: errors,
      });
    } else {
      this.updateTryout(path, method, {
        loading: !(errors && errors.length > 0),
        formErrors: errors,
      });
    }

    if (errors && errors.length > 0)
      return {
        type: "error",
        errors,
      };
    const { swaggerJson } = this.props;
    let data = getData(path, method, form, swaggerJson);

    if (path === "/authorize" && method === "get") {
      return this.setState({
        popup: {
          url: data.url,
          callbackSuccess: (data) => {
            this.tryoutRequestCompleted({ path, method }, true, data, args);
            this.closeAuthPopup();
          },
          callbackFail: () => {
            const message = "Something went wrong please try again";
            this.tryoutRequestCompleted(
              {
                path,
                method,
              },
              false,
              message,
              args
            );
            this.closeAuthPopup();
          },
        },
      });
    }
    if (path === "/token" && method === "post") {
      data = {
        ...data,
        headers: {
          ...data.headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: queryString.stringify(JSON.parse(data.data)),
      };
    }

    let _this = this;
    const tryOutCurrentRequest = $.ajax(data)
      .done((data) => {
        _this.tryoutRequestCompleted({ path, method }, true, data, args);
      })
      .fail((data) => {
        _this.tryoutRequestCompleted({ path, method }, false, data, args);
      });
    this.setState({
      tryOutCurrentRequest,
    });
  };

  cancelCurrentRequest = () => {
    const { tryOutCurrentRequest, popup } = this.state;
    if (tryOutCurrentRequest) {
      tryOutCurrentRequest.abort();
      this.setState({
        tryOutCurrentRequest: null,
      });
    }
    if (popup && popup.url) {
      this.closeAuthPopup();
    }
  };

  validate = (path, method, form) => {
    const { swaggerJson } = this.props;
    const parameters = swaggerJson["paths"][path][method]["parameters"];
    const errors = [];
    if (parameters && parameters.length > 0) {
      parameters.map((param) => {
        if (param.required && !form[param.in][param.name]) {
          errors.push(param);
        }
      });
    }
    return errors;
  };

  openHistoryItemToTryOut = (item) => {
    this.setState({
      historyItem: {
        ...item,
        formErrors: null,
        loading: false,
        response: null,
        formShown: true,
      },
    });
  };

  updateHistoryItemToTryout = (path, method, values) => {
    this.setState({
      historyItem: {
        ...this.state.historyItem,
        ...values,
      },
    });
  };

  render() {
    const {
      tryouts,
      swaggerJson,
      history,
      response,
      tryoutResponseClear,
      tourData,
      documentationId,
      sendContactFormMessage,
      mail,
      applications,
    } = this.props;
    const {
      active,
      tryoutsVisible,
      showHistory,
      onTour,
      popup,
      historyItem,
      shouldOpenResponse,
      responses,
      openTryOutModal,
      modalTextareaValue,
      pinned,
    } = this.state;

    // Determine which tryout to show:
    // If pinned, show the pinned operation
    // If unpinned, show the active operation
    const tryoutToShow = pinned || active;

    console.log("[TRYOUT RENDER] ==== RENDERING TRYOUT WINDOW ====", {
      decision: pinned ? ">>> SHOWING PINNED <<<" : ">>> SHOWING ACTIVE <<<",
      active: active ? `${active.method} ${active.path}` : "NONE",
      pinned: pinned ? `${pinned.method} ${pinned.path}` : "NONE",
      displaying: tryoutToShow
        ? `${tryoutToShow.method} ${tryoutToShow.path}`
        : "NONE",
      tryoutsVisible,
      timestamp: new Date().toISOString(),
    });
    const getTryOut = (tryout, overrideProps) => {
      return (
        tryout && (
          <TryItOut
            {...tryout}
            applications={parseApplications(applications)}
            formShown={tryoutsVisible}
            tryoutsHide={this.tryoutsToggle}
            tryoutsMinify={this.tryoutsMinify}
            swaggerJson={swaggerJson}
            productUuid={this.props.productUuid}
            updateTryout={this.updateTryout}
            pinned={!!this.state.pinned}
            pinTryOut={() => this.pinTryOut(tryout)}
            sendRequest={(form) => {
              this.sendRequest(tryout.path, tryout.method, form);
            }}
            cancelRequest={this.cancelCurrentRequest}
            documentationId={documentationId}
            {...overrideProps}
          />
        )
      );
    };

    const getTryOutFromState = (path, method) => {
      // Handle plain object access instead of Immutable.js
      const tryoutData = tryouts && tryouts[path] && tryouts[path][method];
      console.log("[TRYOUT DEBUG] 15. getTryOutFromState:", {
        path,
        method,
        hasTryoutData: !!tryoutData,
        formShown: tryoutData?.formShown,
        toggleForm: tryoutData?.toggleForm,
      });
      let tryout = parseTryout(tryoutData);
      return getTryOut(tryout);
    };

    const onTryOutModalSend = (message, subject, mail) => {
      // this.setState({
      //   openTryOutModal: true,
      // });

      sendContactFormMessage({
        message: message,
        subject: subject,
        mail: mail,
      });
    };

    const prettyTextAreaParameters = (value) => {
      return value
        ?.replace(/, /g, ",")
        .replace(/,/g, ",\n    ")
        .replace(/^{/g, "{\n    ")
        .replace(/}$/g, "\n}");
    };

    const prettyMailParameters = (value) => {
      return (
        value &&
        value
          .replace(/, /g, ",")
          .replace(/,/g, "<br>")
          .replace(/^{/g, "{<br>")
          .replace(/}$/g, "<br>}")
      );
    };

    const tripleIdenticalFailedResponses = () => {
      const path = active && active.path;
      const method = active && active.method;
      // Handle plain object access instead of Immutable.js
      const tryoutData = tryouts && tryouts[path] && tryouts[path][method];
      const tryout = tryoutData && parseTryout(tryoutData);
      const lastRequest =
        tryout &&
        tryout.form &&
        prettyTextAreaParameters(JSON.stringify(tryout.form.header));
      const lastResponse =
        responses.length > 0 &&
        prettyTextAreaParameters(responses[responses.length - 1].data.body);
      const message = `<p>${modalTextareaValue}</p> <span>Method: ${method}</span> <br><br><span>URL: "${
        window.location.href
      }"</span> <p>Request: ${prettyMailParameters(
        lastRequest
      )}</p> <p>Response: ${prettyMailParameters(lastResponse)}</p>`;
      let count = 0;

      responses
        .filter(
          (response) =>
            !response.success || response.data.body?.indexOf("Error") > -1
        )
        .map((re) => {
          let r = JSON.parse(re.data.body);
          r.exception && delete r.exception.id;
          // Create a new object instead of modifying the read-only one
          return {
            ...re,
            data: {
              ...re.data,
              body: JSON.stringify(r),
            },
          };
        })
        .forEach((failedResponse) => {
          count = 0;
          responses.forEach((r) =>
            failedResponse.data.body === r.data.body ? count++ : null
          );
        });

      if (count < 3) return null;

      return (
        <RedocTryOutModalFailedResponsesForm
          method={method}
          path={path}
          request={lastRequest}
          message={this.props.messageResponse}
          response={lastResponse}
          openModal={openTryOutModal}
          onCloseModal={() => this.setState({ openTryOutModal: false })}
          onSend={() =>
            onTryOutModalSend(message, "Continuous Failed Requests.", mail)
          }
          onFocusOut={(textareaValue) =>
            this.setState({ modalTextareaValue: textareaValue })
          }
        />
      );
    };

    return (
      <div>
        <TryoutTour
          title={swaggerJson.info.title}
          onTour={onTour}
          onTourStop={this.stopTour}
          tourData={tourData}
          sendRequest={this.sendRequest}
          scrollToElement={this.scrollToElement}
        />

        {tryouts &&
        Object.keys(tryouts).length > 0 &&
        tryoutToShow &&
        tryoutToShow.path &&
        tryoutToShow.method
          ? getTryOutFromState(tryoutToShow.path, tryoutToShow.method)
          : null}
        {historyItem
          ? getTryOut(historyItem, {
              updateTryout: this.updateHistoryItemToTryout,
              title: "Try Out From History",
              pinTryOut: null,
              tryoutsHide: null,
              edit: true,
              formShown: historyItem.formShown,
              sendRequest: (form) => {
                this.sendRequest(historyItem.path, historyItem.method, form, {
                  fromTryoutHistory: true,
                  form,
                });
              },
            })
          : null}
        {tripleIdenticalFailedResponses()}
        {showHistory && (
          <RedocTimeline
            startTour={tourData ? this.startTour : null}
            history={history}
            onOpenToTryoutWindow={this.openHistoryItemToTryOut}
            onRepeatRequest={this.sendRequest}
            documentationId={documentationId}
            toggleHistory={this.toggleHistory}
            exportFileName={
              swaggerJson.info.title +
              " " +
              swaggerJson.info.version +
              " " +
              formattedDate()
            }
          />
        )}
        {window.innerWidth > 900 && (
          <Fab className="redocTimeline__fab" onClick={this.toggleHistory}>
            <HistoryIcon />
          </Fab>
        )}
        {response && response.data && (
          <MoveBox
            fullscreenMobile={window.innerWidth <= 900}
            className="tryout-form tryout-form--response"
            title="Response"
            onClose={() => {
              tryoutResponseClear({ documentationId });
            }}
            shouldOpen={shouldOpenResponse}
            expandIcon={<LightBulb />}
          >
            <RedocParamTextArea
              readOnly
              name="response"
              value={response.data}
            />
          </MoveBox>
        )}
        {popup && popup.url && (
          <RedocAuthPopup
            url={popup.url}
            onSuccess={popup.callbackSuccess}
            onFail={popup.callbackFail}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { documentationId } = props;

  // Helper to safely access nested properties whether they're plain objects or Immutable
  const getNestedValue = (obj, path) => {
    if (!obj) return undefined;

    // If obj has getIn method (Immutable), use it
    if (typeof obj.getIn === "function") {
      return obj.getIn(path);
    }

    // Otherwise, traverse plain object
    return path.reduce((current, key) => {
      return current && current[key];
    }, obj);
  };

  // Helper to convert to plain JS if needed
  const toPlainJS = (value) => {
    if (value && typeof value.toJS === "function") {
      return value.toJS();
    }
    return value;
  };

  // Access contact state (plain object)
  const messageResponse = state.contact?.contact?.message;

  // Access tryout state (might be Immutable or plain)
  const tryouts = getNestedValue(state.tryout, ["byId", documentationId]);
  const response = getNestedValue(state.tryout, [
    "byId",
    documentationId,
    "response",
  ]);
  const history = getNestedValue(state.tryout, [
    "byId",
    documentationId,
    "requestHistory",
  ]);

  // Access mail from applicationUser
  const mail = state.applicationUser?.mail;

  // Access apiDocumentation (plain object)
  const tourData = state.apiDocumentation?.byId?.[documentationId]?.tour;

  // Access applications (plain object)
  const applications = state.application?.applicationsById;

  // Process history - handle both Immutable and plain objects
  let processedHistory = [];
  if (history) {
    if (typeof history.valueSeq === "function") {
      // Immutable.js Map
      processedHistory = history
        .valueSeq()
        .toArray()
        .map((item) => toPlainJS(item));
    } else if (typeof history === "object") {
      // Plain object
      processedHistory = Object.values(history).map((item) => toPlainJS(item));
    }
  }

  return {
    applications: applications || {},
    tourData: tourData || null,
    messageResponse,
    tryouts: toPlainJS(tryouts),
    mail,
    history: processedHistory,
    response: toPlainJS(response),
  };
};

const mapDispatchToProps = (dispatch) => ({
  createTryout: (payload) => {
    dispatch(actions.createTryout(payload));
  },
  updateTryout: (payload) => {
    dispatch(actions.updateTryout(payload));
  },
  tryoutRequestCompleted: (payload) => {
    dispatch(actions.tryoutRequestCompleted(payload));
  },
  clearTryoutHistory: (payload) => {
    dispatch(actions.clearTryoutHistory(payload));
  },
  showTryout: (payload) => {
    dispatch(actions.showTryout(payload));
  },
  tryoutResponseClear: (payload) => {
    dispatch(actions.tryoutResponseClear(payload));
  },
  sendContactFormMessage: (payload) => {
    dispatch(actions.sendContactFormMessage(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RedocTryoutManager);
